import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { HeadingAppearance, Size } from './index';

export interface HeadingUniDriver extends BaseUniDriver {
  getAppearance(): Promise<HeadingAppearance | null>;
  getSize(): Promise<Size | null>;
  getTagName(): Promise<keyof HTMLElementTagNameMap>;
  getText(): Promise<string>;
  isLight(): Promise<boolean>;
  isMasked(): Promise<boolean>;
  getId(): Promise<string>;
}
